import * as React from 'react';
import { SingleKeyValueComponent } from 'ui/common';
import { toHex } from 'ui/common/hex-converter';
import { DisplayColor } from 'ui/display-color';
import styles from './tile-top-zone.scss';

export const TileTopZone: React.FC<SingleKeyValueComponent<number>> = (props: SingleKeyValueComponent<number>) => {
    const topZoneColor = props.valueItem && toHex(props.valueItem.backgroundColor);
        
    return (      
      <div className={`${props.className} ${styles.tileTopZone}`} id={props.componentId}>    
        <DisplayColor {...props} hexColor={topZoneColor}/>
      </div>
    );  
};
